import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AssistanceComponent,
  AuthenticationComponent,
  CallbackComponent,
} from '@features/index';
import { AuthenticationGuard } from '@core/index';

const routes: Routes = [
  {
    path: 'authentication',
    component: AuthenticationComponent,
  },
  {
    path: 'assistance',
    component: AssistanceComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/statements/statements.module').then(
        (module) => module.StatementsModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: '**',
    redirectTo: 'authentication',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
